import { NavLink } from 'react-router-dom';
import { cx } from '@platform/core/lib/cx';
import type { ISystemMenuLinkProps } from './ISystemMenuLinkProps';

/**
 * Пункт меню системного модуля (прототип v4 sysGroups.items): 32px · 14px · відступ 22px («Огляд» — 14px), лічильник IBM Plex Mono 11px
 * праворуч; довга назва переноситься (як у прототипі); активний — --accent-soft, акцент, 600 (за адресою або примусово — для вкладених
 * сторінок розділу).
 */
export function SystemMenuLink({ item, top }: ISystemMenuLinkProps) {
  return (
    <NavLink to={item.to} end={item.end}
      className={({ isActive }) => cx('mnav__item sm-item', top && 'sm-item--top', (item.active ?? isActive) && 'is-active')}
      aria-current={item.active ? 'page' : undefined}>
      <span className="mnav__label">{item.label}</span>
      {item.count !== undefined && <span className="mnav__count">{item.count}</span>}
    </NavLink>
  );
}
